import React from "react";
import styles from "./Docs.module.scss";
import docsData from "../../data/docsData.json";

const Docs: React.FC = () => {
    return (
        <div className={styles.docs}>
            {docsData.map((doc, idx) =>
                <a key={idx} className={styles.docItem} href={doc.link} target="_blank">{doc.title}</a>
            )}
        </div>
    )
}

export default Docs;